import React from 'react';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { ProductCard } from '../../ProductCard';
import { AlgoliaHitTransformer } from '../../Algolia/transformers/AlgoliaHitTransformer';
import { TrackingDescriptorType } from '../../Tracking/types';
import { useCustomerContext } from '../../context/CustomerContextProvider';
import { useProductCompare } from '../../ProductCompare';
import { styles } from './AlternativesContainer.css';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';

export type AlternativesContainerProps = {
  isLoggedIn?: boolean;
  tileVariant: 'fullWidth' | 'minified';
  alternatives: Array<AlgoliaProductHit>;
  onAddToCart: (
    event: React.SyntheticEvent,
    hit: AlgoliaProductHit,
    variantId?: number,
    trackingDescriptor?: TrackingDescriptorType
  ) => Promise<boolean>;
};

export const AlternativesContainer = ({
  tileVariant = 'minified',
  alternatives,
  onAddToCart,
}: AlternativesContainerProps) => {
  const { shouldShowCompare, addItemToCompare, isAddedToCompare } = useProductCompare();
  const { isLoggedIn, handleUpdateWishlist, getIsInWishlist } = useCustomerContext();

  const wishlistProps =
    tileVariant !== 'minified'
      ? {
          isLoggedIn,
          onUpdateWishlist: handleUpdateWishlist,
          getIsInWishlist,
        }
      : {};

  const compareProps =
    tileVariant !== 'minified'
      ? {
          getShouldShowCompare: shouldShowCompare,
          onCompare: addItemToCompare,
          getIsCompared: isAddedToCompare,
        }
      : {};

  return (
    <div className={styles.container}>
      {alternatives.map(alternative => {
        return (
          <ProductCard
            variant={tileVariant}
            {...AlgoliaHitTransformer.toProductCardProps(alternative, {
              trackingDescriptor: {
                page: 'alternatives-slideout',
                group: 'googleRelated',
                category: 'alternatives',
                currency: getStoreCurrency(),
                ecommerceExtraProps: {
                  list: 'similar-recai',
                },
              },
            })}
            shouldHideWishlist={tileVariant === 'minified'}
            shouldHideCartOverlay
            shouldHideNotifyMe
            shouldRemainInAddedState
            key={alternative.objectID}
            onAddToCart={
              onAddToCart
                ? (e, _sku, variantId, eventData) =>
                    onAddToCart(e, alternative, variantId, eventData?.trackingDescriptor)
                : undefined
            }
            {...wishlistProps}
            {...compareProps}
          />
        );
      })}
    </div>
  );
};
